export interface SeekableFragment {
  start: number;
  duration: number;
  // EXT-X-PROGRAM-DATE-TIME as epoch milliseconds.
  programDateTime: number | null;
}

/**
 * Return the media time aligned with a wall-clock instant.
 *
 * Silent gaps make media and wall-clock time diverge. An instant inside a gap
 * resolves to the next fragment. Return null when no fragment has a program date.
 */
export const mediaTimeForDate = (
  fragments: readonly SeekableFragment[],
  dateMs: number
): number | null => {
  const timed = fragments.filter(
    (fragment): fragment is SeekableFragment & { programDateTime: number } =>
      fragment.programDateTime != null
  );
  if (timed.length === 0) return null;

  let last: (SeekableFragment & { programDateTime: number }) | null = null;
  for (const fragment of timed) {
    const startMs = fragment.programDateTime;
    if (dateMs < startMs) return fragment.start;
    if (dateMs < startMs + fragment.duration * 1000)
      return fragment.start + (dateMs - startMs) / 1000;
    last = fragment;
  }

  return last === null ? null : last.start + last.duration;
};
